// extracted by mini-css-extract-plugin
export default {"container":"Izin_container__DNcD7","table_wrapper":"Izin_table_wrapper__PoqAR","header_container":"Izin_header_container__8MAj3"};